import app from 'flarum/forum/app';
import IndexPage from "flarum/forum/components/IndexPage";
import Mithril from "mithril";
import Stream from "flarum/common/utils/Stream";
import LinkButton from "flarum/common/components/LinkButton";
import Watermark from "../warterMarkJS";
import Switch from "flarum/common/components/Switch";
import Select from "flarum/common/components/Select";

export default class ConfirmPTSiteListPage<CustomAttrs> extends IndexPage {
  private query: string = Stream();
  private type: any = Stream('info');
  private moreResults: boolean = false;
  private list: any = [];
  private loading: boolean = true;

  oncreate(vnode: Mithril.VnodeDOM<CustomAttrs, this>) {
    super.oncreate(vnode);
    app.setTitle(app.translator.trans('mattoid-pt-site-information.forum.title'))

    Watermark.set('');

    this.loadResults()
  }

  view() {
    return (
      <div class="container">
        <div class="DiscussionPage-stream">
          <div class="PostStream">
            <div class="Post-body">
              <h2
                class="BadgeOverviewTitle">{app.translator.trans('mattoid-pt-site-information.forum.confirm-title')}</h2>
              <nav class="TagsPage-nav IndexPage-nav sideNav" style="width: 100%">
                <div className="inlineBlock">
                  <input required class="FormControl" style="width: 200px" type="text" onblur={() => {
                    this.list = []
                    this.loadResults()
                  }} placeholder={app.translator.trans('mattoid-pt-site-information.forum.confirm-query')}
                         bidi={this.query}/>
                </div>
                <div className="inlineBlock margin-left-10">
                  <Select
                    style="width: 150px"
                    value={this.type()}
                    options={{
                      'info': app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-info'),
                      'box': app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-box'),
                      'hr': app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-hr'),
                      'check': app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-check'),
                      'claim': app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-claim'),
                      'level': app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-level'),
                    }}
                    onchange={(e) => {
                      this.type(e)
                      this.loadResults()
                    }}
                  />
                </div>
              </nav>

              {this.loading && (
                <div class="DiscussionList">
                  <div class="DiscussionList-loadMore">
                    <div aria-label="loading…" role="status" data-size="medium"
                         class="LoadingIndicator-container LoadingIndicator-container--block LoadingIndicator-container--medium">
                      <div aria-hidden="true" class="LoadingIndicator"></div>
                    </div>
                  </div>
                </div>
              )}

              <div class="TagsPage-content sideNavOffset">
                { !this.loading &&
                  this.list.map(item => {
                    return (
                      <div className="frame" style="padding: 20px">
                        <div className="inlineBlock" style="width: 200px">
                          {item.attributes.displayAnotherName ? item.attributes.displayAnotherName : item.attributes.another_name}
                        </div>
                        <div className="inlineBlock" style="width: 200px">
                          <img className="Invite-Icon" src={item.attributes.userImg}/>
                          {item.attributes.username}
                        </div>
                        <div className="inlineBlock" style="width: 200px">
                          {item.attributes.siteType}
                        </div>
                        <div className="inlineBlock" style="width: 200px">
                        {item.attributes.created_at}
                        </div>
                        <div className="inlineBlock Site-Right-Aligned">
                          {
                            LinkButton.component({
                              className: 'Button',
                              style: 'display: inline',
                              href: '/pt/site/' + this.type() + '/confirm/' + item.attributes.site_id + '/' + (item.attributes.level_id ? item.attributes.level_id : item.attributes.id ),
                            }, app.translator.trans('mattoid-pt-site-information.forum.confirm-site'))
                          }
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  parseResults(results) {
    this.list = [];
    this.loading = false;
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.list, results.payload.data);
    m.redraw();

    return results;
  }

  loadResults() {
    this.loading = true;

    const filters = {
      query: this.query(),
      type: this.type()
    };

    return app.store
      .find("/pt/site/confirm/list", {
        filter: filters,
      })
      .catch(() => {
      })
      .then(this.parseResults.bind(this));
  }
}
